import React, { ComponentProps } from 'react';

import SideNavigation from '@adsk/alloy-side-navigation';
import {
  RemoteComponent,
  RemoteComponentProps,
} from '@adsk/exo-skeleton-react';

import RemoteSideNavigationError from './RemoteSideNavigationError';
import SideNavigationLoader from './SideNavigationLoader';

type RemoteSideNavigationProps = Omit<
  RemoteComponentProps<ComponentProps<typeof SideNavigation>>,
  'renderLoader' | 'renderError'
>;

const RemoteSideNavigation = ({ ...props }: RemoteSideNavigationProps) => (
  <RemoteComponent<ComponentProps<typeof SideNavigation>>
    renderLoader={() => <SideNavigationLoader />}
    renderError={() => <RemoteSideNavigationError />}
    {...props}
  />
);

export default RemoteSideNavigation;
